import {
  GET_FEED_CARDS,
  FEED_CARDS_LOADING,
  FEED_CARDS_ERROR,
} from "../actionTypes";

const initialState = {
  cards: [],
  loading: false,
  error: null,
  currentPage: 1,
  hasMore: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FEED_CARDS_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case GET_FEED_CARDS:
      // Page 1 replaces; page 2+ appends (infinite scroll)
      const newCards = payload.page === 1
        ? payload.cards
        : [...state.cards, ...payload.cards];
      return {
        ...state,
        cards: newCards,
        currentPage: payload.page,
        hasMore: payload.hasMore,
        error: null,
      };

    case FEED_CARDS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    default:
      return state;
  }
};
